<template>
  <div class="my-uploaded-template" theme>
    <div id="theme-my-uploaded-header" />
    <div id="theme-my-uploaded-leftside" />
    <div id="theme-my-uploaded-content" />
    <div id="theme-my-uploaded-rightside" />
    <div id="theme-my-uploaded-footer" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'my-uploaded',
      parts: [
        {
          elem: '#theme-my-uploaded-header',
          htmlFile: 'header'
        },
        {
          elem: '#theme-my-uploaded-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#theme-my-uploaded-content',
          htmlFile: 'content'
        },
        {
          elem: '#theme-my-uploaded-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#theme-my-uploaded-footer',
          htmlFile: 'footer'
        }
      ]
    }
  }
}
</script>

<style scoped>
.my-uploaded-template {
  min-height: 100px;
  margin-top: -35px;
}
</style>
